import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { fleetType, fleetsType } from '../../types';

const initialState: fleetsType = {
    fleets: [],
    fleets_size: ['bicycle', 'scooter', 'mini bakkie', 'bakkie', 'half truck', '4ton', '8ton', 'van'],
    is_adding_fleet: false,
    is_loading_fleets: false,
    is_deleting_fleet: false,
    is_updating_fleet: false,
};

const fleetSlice = createSlice({
    name: 'fleet',
    initialState,
    reducers: {
        getFleetsSuccess: (state, actions: PayloadAction<Array<fleetType>>) => {
            return {
                ...state,
                fleets: actions.payload
            };
        },
        onAddingFleet: (state, actions: PayloadAction<boolean>) => {
            return {
                ...state,
                is_adding_fleet: actions.payload
            };
        },
        onLoadingFleets: (state, actions: PayloadAction<boolean>) => {
            return {
                ...state,
                is_loading_fleets: actions.payload
            };
        },
        onDeletingFleet: (state, actions: PayloadAction<boolean>) => {
            return {
                ...state,
                is_deleting_fleet: actions.payload
            };
        },
        onUpdatingFleet: (state, actions: PayloadAction<boolean>) => {
            return {
                ...state,
                is_updating_fleet: actions.payload,
            };
        },
    }
});

export const { getFleetsSuccess, onAddingFleet, onLoadingFleets, onDeletingFleet, onUpdatingFleet } = fleetSlice.actions;

export default fleetSlice.reducer;